import { render } from "./PaybackForm.vue?vue&type=template&id=c2648cf4"
import script from "./PaybackForm.vue?vue&type=script&lang=js"
export * from "./PaybackForm.vue?vue&type=script&lang=js"
script.render = render

export default script